let index: number = 0;

const SubstanceByStoreGridPluginSettings: IPluginSettings = {
    name: 'МНН',
    mnemocode: 'substance_by_store_plugin',
    permission: 'Substance',
    columns: [{
        order: index++,
        propertyName: 'substanceNameRus',
        propertyType: 'string',
        displayName: 'МНН (рус.)',
        visibility: true,
        favoriteFilter: true,
        width: 150
    }, {
        order: index++,
        propertyName: 'substanceNameLat',
        propertyType: 'string',
        displayName: 'МНН (лат.)',
        visibility: true,
        favoriteFilter: true,
        width: 150
    }, {
        order: index++,
        propertyName: 'important',
        propertyType: 'boolean',
        displayName: 'ЖНВЛП',
        visibility: true,
        favoriteFilter: true,
        width: 150
    }, {
        order: index++,
        propertyName: 'isLs',
        propertyType: 'boolean',
        displayName: 'Лек. средство',
        visibility: true,
        favoriteFilter: false,
        width: 150
    }, {
        order: index++,
        propertyName: 'isPrescription',
        propertyType: 'boolean',
        displayName: 'Рецептурный',
        visibility: true,
        favoriteFilter: false,
        width: 150
    }],
}

export default SubstanceByStoreGridPluginSettings